/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Premium_Logo_AltInputs */

const en_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const id_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ms_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ca_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const cs_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const da_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const de_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const et_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const es_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const fr_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const hr_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const it_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const lv_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const lt_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const hu_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const nl_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const nb_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const pl_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const pt_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ro_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const sk_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const sl_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const fi_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const sv_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave premium`)
};

const vi_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave cao cấp`)
};

const tr_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const el_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const bg_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ru_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Премиум`)
};

const sr_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const uk_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ka_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave პრემიუმი`)
};

const hi_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव प्रीमियम`)
};

const th_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const ko_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 프리미엄`)
};

const zh_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

const zh_tw_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 高級版`)
};

const ja_brave_premium_logo_alt = /** @type {(inputs: Brave_Premium_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium`)
};

/**
* | output |
* | --- |
* | "Brave Premium" |
*
* @param {Brave_Premium_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_premium_logo_alt = /** @type {((inputs?: Brave_Premium_Logo_AltInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Premium_Logo_AltInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_premium_logo_alt(inputs)
	if (locale === "ms") return ms_brave_premium_logo_alt(inputs)
	if (locale === "ca") return ca_brave_premium_logo_alt(inputs)
	if (locale === "cs") return cs_brave_premium_logo_alt(inputs)
	if (locale === "da") return da_brave_premium_logo_alt(inputs)
	if (locale === "de") return de_brave_premium_logo_alt(inputs)
	if (locale === "et") return et_brave_premium_logo_alt(inputs)
	if (locale === "es") return es_brave_premium_logo_alt(inputs)
	if (locale === "fr") return fr_brave_premium_logo_alt(inputs)
	if (locale === "hr") return hr_brave_premium_logo_alt(inputs)
	if (locale === "it") return it_brave_premium_logo_alt(inputs)
	if (locale === "lv") return lv_brave_premium_logo_alt(inputs)
	if (locale === "lt") return lt_brave_premium_logo_alt(inputs)
	if (locale === "hu") return hu_brave_premium_logo_alt(inputs)
	if (locale === "nl") return nl_brave_premium_logo_alt(inputs)
	if (locale === "nb") return nb_brave_premium_logo_alt(inputs)
	if (locale === "pl") return pl_brave_premium_logo_alt(inputs)
	if (locale === "pt") return pt_brave_premium_logo_alt(inputs)
	if (locale === "ro") return ro_brave_premium_logo_alt(inputs)
	if (locale === "sk") return sk_brave_premium_logo_alt(inputs)
	if (locale === "sl") return sl_brave_premium_logo_alt(inputs)
	if (locale === "fi") return fi_brave_premium_logo_alt(inputs)
	if (locale === "sv") return sv_brave_premium_logo_alt(inputs)
	if (locale === "vi") return vi_brave_premium_logo_alt(inputs)
	if (locale === "tr") return tr_brave_premium_logo_alt(inputs)
	if (locale === "el") return el_brave_premium_logo_alt(inputs)
	if (locale === "bg") return bg_brave_premium_logo_alt(inputs)
	if (locale === "ru") return ru_brave_premium_logo_alt(inputs)
	if (locale === "sr") return sr_brave_premium_logo_alt(inputs)
	if (locale === "uk") return uk_brave_premium_logo_alt(inputs)
	if (locale === "ka") return ka_brave_premium_logo_alt(inputs)
	if (locale === "hi") return hi_brave_premium_logo_alt(inputs)
	if (locale === "th") return th_brave_premium_logo_alt(inputs)
	if (locale === "ko") return ko_brave_premium_logo_alt(inputs)
	if (locale === "zh") return zh_brave_premium_logo_alt(inputs)
	if (locale === "zh-tw") return zh_tw_brave_premium_logo_alt(inputs)
	if (locale === "ja") return ja_brave_premium_logo_alt(inputs)
	return en_brave_premium_logo_alt(inputs)
});